<template>
  <div>
    <h2 class="col-lg-12 text-center mb-3">{{ $t('add') }}</h2>
    <ReservationForm @submit-requested="submitRequested"></ReservationForm>
  </div>
</template>
 
<script>
import { mapActions } from 'vuex'
import ReservationForm from './ReservationForm.vue'

  export default {
  components: { ReservationForm },
  methods: {
    ...mapActions('reservations', ['postReservation']),
    submitRequested (input) {
      this.postReservation(input);
    },
  }
}
</script> 
 
<style scoped>
thead > tr > th
{
  text-align: unset !important;
}
</style> 